import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GuestProductPayment } from 'models';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class GuestProductPaymentsService {
	constructor(private http: HttpClient) {}

	public get(guestUserId: string): Observable<GuestProductPayment[]> {
		return this.http.get<GuestProductPayment[]>(`api/guestproductpayment/get/${guestUserId}`);
	}
}
